import React from 'react';
import {
  BlurOverlay,
  FeaturedImg,
  FeaturedOnSection,
  FeatureImgContainer,
  ImgMarquee,
} from './styled';
import { PrTitle } from '../AwardsSection/styled';

const FeaturedOnNew = () => {
  const featuredNewData = [
    {
      imgUrl:
        'https://images.myloapp.in/NestJsUploads/1683115628455-businessWorld.webp',
      name: 'businessWorld',
      deeplink: '',
    },
    {
      imgUrl: 'https://images.myloapp.in/NestJsUploads/1683106006773-cnbc.webp',
      name: 'cnbc',
      deeplink: '',
    },
    {
      imgUrl:
        'https://images.myloapp.in/NestJsUploads/1683106311449-financialExp.webp',
      name: 'financialExp',
      deeplink: '',
    },

    {
      imgUrl:
        'https://images.myloapp.in/NestJsUploads/1683106006776-economicTimes.webp',
      name: 'economicTimes',
      deeplink: '',
    },

    {
      imgUrl:
        'https://images.myloapp.in/NestJsUploads/1683115628457-businessToday.webp',
      name: 'businessToday',
      deeplink: '',
    },
  ];
  const featuredNewData2 = [
    {
      imgUrl: 'https://images.myloapp.in/NestJsUploads/1683106311451-toi.webp',
      name: 'toi',
      deeplink: '',
    },
    {
      imgUrl:
        'https://images.myloapp.in/NestJsUploads/1683106006776-inc42.webp',
      name: 'inc42',
      deeplink: '',
    },
    {
      imgUrl:
        'https://images.myloapp.in/NestJsUploads/1683106311452-businessStandard.webp',
      name: 'businessStandard',
      deeplink: '',
    },

    {
      imgUrl:
        'https://images.myloapp.in/NestJsUploads/1683106311451-yourStory.webp',
      name: 'yourStory',
      deeplink: '',
    },
    {
      imgUrl: 'https://images.myloapp.in/NestJsUploads/1683106006775-ani.webp',
      name: 'ani',
      deeplink: '',
    },
  ];
  return (
    <FeaturedOnSection>
      <PrTitle>AS SEEN IN</PrTitle>
      <FeatureImgContainer>
        <BlurOverlay />
        {/* <BlurOverlayRight /> */}

        <ImgMarquee className="marquee">
          <div className="marqueeInner">
            {featuredNewData.map((feature, index) => {
              // if (index <= 6)
              return (
                <FeaturedImg
                  key={'img' + index}
                  index={index}
                  src={feature.imgUrl}
                  alt=""
                />
              );
            })}
          </div>
          <div className="marqueeInner">
            {featuredNewData.map((feature, index) => {
              // if (index <= 6)
              return (
                <FeaturedImg
                  key={'img' + index}
                  index={index}
                  src={feature.imgUrl}
                  alt=""
                />
              );
            })}
          </div>
        </ImgMarquee>

        <ImgMarquee marqueeOrder={2}>
          <div className="marqueeInner">
            {featuredNewData2.map((feature, index) => {
              // if (index > 5)
              return (
                <FeaturedImg
                  key={'imgId' + index}
                  index={index}
                  src={feature.imgUrl}
                  alt=""
                />
              );
            })}
          </div>
          <div className="marqueeInner" aria-hidden="true">
            {featuredNewData2.map((feature, index) => {
              // if (index > 4)
              return (
                <FeaturedImg
                  key={'imgI' + index}
                  index={index}
                  src={feature.imgUrl}
                  alt=""
                />
              );
            })}
          </div>
        </ImgMarquee>
      </FeatureImgContainer>
    </FeaturedOnSection>
  );
};

export default FeaturedOnNew;
